import { render, staticRenderFns } from "./Administration.vue?vue&type=template&id=b510d98e&scoped=true"
import script from "./Administration.vue?vue&type=script&lang=js"
export * from "./Administration.vue?vue&type=script&lang=js"
import style0 from "./Administration.vue?vue&type=style&index=0&id=b510d98e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b510d98e",
  null
  
)

export default component.exports